import React, { useState } from 'react';
import './Stepper.css';

export default function SimpleMobileStepper({
    totalSteps,
    handleNext,
    handleBack,
    activeStep,
    isFormSubmitted=false,
          isLastStep=false
        }: {
    totalSteps: number;
    handleNext: () => void;
    handleBack: () => void;
    activeStep: number;
    isFormSubmitted?: boolean;
    isLastStep?: boolean;
    nextButtonLabel?: string;
}) {
    const finalSteps = totalSteps - 1;
  return (
    <div className="stepper-container-new mt-3">
      
      <div className="stepper-buttons">
        <button
          className="stepper-btn"
          onClick={handleBack}
          disabled={activeStep === 0}
          type="button"
        >
          ← Back
        </button>
        <div className="dots">
        {Array.from({ length: finalSteps }).map((_, index) => (
          <span
            key={index}
            className={`dot ${index === activeStep ? 'active' : ''}`}
          />
        ))}
      </div>
        <button
          className="stepper-btn"
          onClick={handleNext}
          disabled={isFormSubmitted}
          type="button"
        >
          {isLastStep ? (isFormSubmitted ? 'Submitting..' : "Submit" ): "Next →"}
        </button>
      </div>
    </div>
  );
}
